import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPrinterNotConfiguredDialog } from '../Selectors'
import ConfirmModalV2 from '../../components/ConfirmModalV2'
import { setPrinterNotConfiguredDialog } from '../ActionCreators'
import { setRoute } from '../../VNRoutes/ActionCreators'
import { setManagerApprovalPrompt } from '../../VNManagerApproval/ActionCreators'
import { getRequireManagerPinForConfiguration } from '../../selectors/menus'
import { getNetworkAvailableValue } from '../../utils/networkConnected'
import { APPLICATION_STRINGS } from '../../strings'

export const VNPrinterNotConfiguredDialog = () => {
  const dispatch = useDispatch()

  const open = useSelector((state) => getPrinterNotConfiguredDialog(state))
  const requireManagerPinForConfiguration = useSelector((state) => getRequireManagerPinForConfiguration(state))

  const networkConnected = getNetworkAvailableValue()

  const cancelHandler = useCallback(() => {
    dispatch(setPrinterNotConfiguredDialog({ open: false }))
  }, [dispatch])

  const configureHandler = useCallback(() => {
    if (!requireManagerPinForConfiguration) {
      dispatch(setPrinterNotConfiguredDialog({ open: false }))
      dispatch(setRoute('/revenue-center-setup', { printerSetup: true }))
      return
    }

    const onSuccess = () => {
      dispatch(setRoute('/revenue-center-setup', { printerSetup: true }))
    }

    dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Configure Printer' }))
    dispatch(setPrinterNotConfiguredDialog({ open: false }))
  }, [dispatch, requireManagerPinForConfiguration])

  if (!open) {
    return null
  }

  if (networkConnected) {
    return (
      <ConfirmModalV2
        headerText={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_HEADER_TEXT}
        subtext={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_SUB_HEADER_TEXT}
        buttonOneText={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_CANCEL}
        onButtonOneClick={cancelHandler}
        buttonTwoText={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_CONFIGURE_PRINTER}
        onButtonTwoClick={configureHandler}
      />
    )
  }

  return (
    <ConfirmModalV2
      headerText={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_HEADER_TEXT}
      subtext={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_SUB_HEADER_TEXT}
      buttonTwoText={APPLICATION_STRINGS.PRINTER_NOT_CONFIGURED_DIALOG_CANCEL}
      onButtonTwoClick={cancelHandler}
      singleButtonOnly
    />
  )
}
